import React, { useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CategoriesSlider = ({ categories = [], onCategorySelect, selectedCategoryId, className = '' }) => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    scrollRef.current?.scrollBy({ left: dir === 'left' ? -240 : 240, behavior: 'smooth' });
  };

  if (!categories.length) return null;

  const pill = (active) =>
    active
      ? 'bg-slate-900 text-white border-slate-900 shadow-md shadow-slate-900/15'
      : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:shadow-md';

  return (
    <div className={`relative ${className}`}>
      <div className="flex items-end justify-between gap-4 mb-4 px-1">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-sky-700 mb-1">
            Browse by type
          </p>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">
            Property categories
          </h2>
        </div>
        <div className="hidden sm:flex items-center gap-2">
          <button
            type="button"
            onClick={() => scroll('left')}
            className="w-9 h-9 rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 flex items-center justify-center"
            aria-label="Scroll left"
          >
            <Icon name="ChevronLeft" size={16} />
          </button>
          <button
            type="button"
            onClick={() => scroll('right')}
            className="w-9 h-9 rounded-full border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 flex items-center justify-center"
            aria-label="Scroll right"
          >
            <Icon name="ChevronRight" size={16} />
          </button>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        <button
          type="button"
          onClick={() => onCategorySelect('all')}
          className={`flex-shrink-0 flex items-center gap-3 pl-2 pr-4 py-2 rounded-2xl border transition-all ${pill(
            String(selectedCategoryId) === 'all' || !selectedCategoryId
          )}`}
        >
          <span
            className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              String(selectedCategoryId) === 'all' || !selectedCategoryId
                ? 'bg-white/15'
                : 'bg-slate-50'
            }`}
          >
            <Icon name="LayoutGrid" size={20} />
          </span>
          <span className="text-sm font-semibold pr-1">All</span>
        </button>

        {categories.map((category) => {
          const active = String(selectedCategoryId) === String(category.id);
          return (
            <button
              key={category.id}
              type="button"
              onClick={() => onCategorySelect(String(category.id))}
              className={`flex-shrink-0 flex items-center gap-3 pl-2 pr-4 py-2 rounded-2xl border transition-all ${pill(
                active
              )}`}
            >
              <span className="w-12 h-12 rounded-xl overflow-hidden bg-slate-100 flex-shrink-0">
                {category.image ? (
                  <Image
                    src={category.image}
                    alt={category.category}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="w-full h-full flex items-center justify-center">
                    <Icon name="Home" size={18} className="text-slate-400" />
                  </span>
                )}
              </span>
              <span className="text-sm font-semibold whitespace-nowrap">{category.category}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoriesSlider;
